import { useState } from "react";
import QuizList from "@admin/components/Quizzes/QuizList";
import QuizModal from "@admin/components/Modals/QuizModal";

const Quizzes = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <button className="btn ml-auto" onClick={openModal}>
          Add Quiz
        </button>
        <QuizModal open={isModalOpen} closeModal={closeModal} />
      </div>
      <QuizList />
    </div>
  );
};

export default Quizzes;
